// extracted by mini-css-extract-plugin
module.exports = {"ya-share2-horizontal":"YandexShare_ya-share2-horizontal__2Zr_W","ya-share2-light":"YandexShare_ya-share2-light__2GiTN","ya-share2-mobile":"YandexShare_ya-share2-mobile__3tVtB"};